import BaseProxy from './Proxy';

class VideoProxy extends BaseProxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor() {
    super('vms-admin/video-search');
  }
}

export default VideoProxy;